import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

type RuntimeConfig = {
    clientId: number;
    clientCode: string;
    /** Set from the client response during bootstrap; see CaptchaService. */
    turnstileSiteKey: string;
};

declare global {
    var runtimeConfig: RuntimeConfig;
}

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    constructor(private http: HttpClient) {}

    private formatErrors(error: any) {
        return throwError(error.error);
    }

    private getApiUrl() {
        return environment.apiUrl;
    }

    /** GET call to the server with specified api endpoint (path) and optional parameters (params) */
    get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
        return this.http
            .get(`${this.getApiUrl()}${path}`, { params })
            .pipe(catchError(this.formatErrors));
    }

    post(path: string, body: Object = {}): Observable<any> {
        return this.http
            .post(`${this.getApiUrl()}${path}`, body)
            .pipe(catchError(this.formatErrors));
    }

    put(path: string, body: Object = {}): Observable<any> {
        return this.http
            .put(`${this.getApiUrl()}${path}`, body)
            .pipe(catchError(this.formatErrors));
    }

    patch(path: string, body: Object = {}): Observable<any> {
        return this.http
            .patch(`${this.getApiUrl()}${path}`, body)
            .pipe(catchError(this.formatErrors));
    }
}
